module.exports = __webpack_public_path__ + "img/vip-mobile-2.124c463d.jpeg";